import { useForm } from "react-hook-form";
import React, { useEffect, useState,useContext } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Home/Sidebar";
import Loader from '../Loader/Loader';
import './Company.css';
import { AuthContext } from "../../contexts/AuthProvider";


const Company = () => {
  const [data, setData] = useState();
  const [descriptionValue, setDescriptionValue] = useState("");
  const [companyId, setCompanyId] = useState("");
  
  const [isLoading, setIsLoading] = useState(true);

  const { register } = useForm();

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://apichatgptresponse.managedcoder.com/api/company/getdata/"+user.email
        );
        const responsedata = await response.json();
        if (responsedata != null) {
          setData(responsedata);
          setCompanyId(responsedata._id);         
          setDescriptionValue(responsedata.companydata);
          setIsLoading(false);
        } else {
          setCompanyId(null);
          setDescriptionValue(null);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  let id = companyId;
  let companydata = descriptionValue;
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    let emailid = user.email;
    const payload = { 
      emailid, 
      companydata 
    }
    try {
      const response = await fetch(
        "https://apichatgptresponse.managedcoder.com/api/company/adddata/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      console.log("Success:", data);
    } catch (error) {
      console.error("Error:", error);
    }
    navigate("/home");
  };
  return (
    <>
    { isLoading ? (<Loader />) : (<div className="row">
        <div className="col-3">
         <Sidebar />
        </div>
        <div className="col-9">
          <div className="article-title form-update">
            <Row className="">
              <div className="mb-3">
                <h3 className="title">About Company</h3>
              </div>
              <Col md="9">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <Form.Group className="mb-4">
                        {/* <Form.Label className="description-header">Description</Form.Label> */}
                        
                        {data ? (
                          <Form.Control
                            key={data._id}
                            as="textarea"
                            placeholder="Description"
                            rows={10}                                              
                            value={descriptionValue}
                            onChange={(e) => setDescriptionValue(e.target.value)}
                          />
                        ) : (
                          <Form.Control
                            as="textarea"
                            placeholder="Description of the Company"
                            rows={10}
                            value={descriptionValue}
                            onChange={(e) => setDescriptionValue(e.target.value)}
                          />
                        )}

                        <br />
                        <div className="btn-wrapper">
                          {data ? (                     
                            <Button type="submit" className="save-btn">
                              Update
                            </Button>
                          ) : (
                            <Button type="submit" className="save-btn">
                              Save
                            </Button>                     
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>) }
      

      
    </>
  );
};

export default Company;
